import { createReducer } from "@reduxjs/toolkit"
import { SUBJECTS } from "lib/leeruniek/constants"
import * as R from "ramda"

const initialState = {
  subjects: [],
  isLoading: true,
}

export default createReducer(initialState, (builder) => {
  builder
    .addCase("GET_SUBJECTS_REQUEST", (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase("GET_SUBJECTS_SUCCESS", (state, action) => ({
      ...state,
      subjects: R.sortBy(R.prop("position"))(
        action.payload.map((subject) => ({
          ...subject,
          shortLabelWithoutSpaces: Object.keys(SUBJECTS).find(
            (key) => SUBJECTS[key] === subject.shortLabel,
          ),
        })),
      ),
      isLoading: false,
    }))
    .addCase("GET_SUBJECTS_FAILURE", (state) => ({
      ...state,
      isLoading: false,
    }))
})
